//@ts-strict-ignore
import Formatters from '../components/grid-addons/formatters';
import getIn from '../components/connectedForm/utils/getIn';
import { ICustomColumn } from './setColumnsFromArray';

export function getLotAttributeRowMetaData(rowData, column) {
  let values;
  if (column.options?.valuesPath) {
    values = getIn(rowData, column.options.valuesPath);
  } else {
    values = rowData.attributeValues;
  }

  return {
    attributeValues: values,
    attributeConfig: column.options.attributeConfig,
  };
}

/**
 * Important - DO NOT USE DIRECTLY - Go via 'useLotAttributesForWorkspace', which appropriately memoises the result.
 */
export function setLotAttributeColumns(
  lotAttributeConfig,
  valuesPath = 'lotAttributeValues',
  columnKey = 'lotAttributeValues.attributeConfig.title'
) {
  const customColumns: { [key: string]: ICustomColumn } = {};
  lotAttributeConfig.map((attr) => {
    let name = attr.node.title;
    // Overrides for Internal Attributes
    if (name === 'MOVEMENT_DATE') {
      name = 'FIFO / Batch Movement Date';
    } else if (name === 'BATCH') {
      name = 'Batch';
    }
    customColumns[`${columnKey}.${attr.node.id}`] = {
      name: name,
      fieldName: valuesPath,
      sortable: false,
      type: attr.node.attributeType,
      objectType: null,
      formatter: Formatters.LotAttributeWorkspaceFormatter,
      options: { attributeConfig: attr.node, valuesPath },
      getRowMetaData: getLotAttributeRowMetaData,
    };
  });
  return customColumns;
}
